import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";
import { format, compareAsc } from "date-fns";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import * as util from "@app/lib/utility";

import { SelectStatPeriod, getDefinedPeriod } from "@app/components/Stat/SelectStatPeriod";
import ExcelDownloadBtn from "@app/components/Stat/ExcelDownloadBtn";
import ViewOption from "./Components/ViewOption";

import Branch from "./Branch/Branch";
import Nursery from "./Branch/Nursery";
import Class from "./Branch/Class";

import "./Components/style.css";
import BCGScatter from "@app/pages/TAS/Branch/BCGScatter/index";

const minDate = "2022-03-01"; // 통계 데이터 제공 시작일
const showLastYearShortCut = new Date().getFullYear() >= 2023; // 2023년부터 이전 학년도 버튼 활성화
const getPeriodToStat = ({ startDate, endDate, type }) => {
    return {
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd"),
        type: type,
    };
};
const getBranchInfo = () => {
    let branch = util.getLoginBranchInfo();
    if (!branch) {
        branch = { id: 0, name: "전체" };
    }
    return branch;
};
const StatTomonoteBranch = (props) => {
    const [loadingData, setLoadingData] = useState(false);
    const [isFirstDataLoaded, setFirstDataLoaded] = useState(false);

    const [statPeriod, setStatPeriod] = useState(getPeriodToStat(getDefinedPeriod("week", "current")));

    const [isRoleBranch] = useState(util.isRoleBranch());
    const [branchList, setBranchList] = useState(false);

    const [selectedBranch, setBranch] = useState(getBranchInfo());
    const [statBranch, setStatBranch] = useState(false);

    const [selectedNurseryUniq, setNurseryUniq] = useState(false);
    const [statNurseryUniq, setStatNurseryUniq] = useState(false);
    const [classList, setClassList] = useState(false);

    const [selectedClass, setClass] = useState(false);
    const [statClass, setStatClass] = useState(false);

    const parentRef = useRef();

    useEffect(() => {
        if (!isRoleBranch) {
            if (statBranch) return;
            setLoadingData(true);
            commonData.getBranchList(axios, (err, branchList) => {
                setLoadingData(false);
                if (err) {
                    toast.error(err);
                } else {
                    branchList = [{ id: 0, name: "전체" }].concat(branchList);
                    setBranchList(branchList);
                    getStatBranch();
                }
            });
        } else {
            getStatBranch();
        }
        return () => {};
    }, [selectedBranch]);

    useEffect(() => {
        if (!isRoleBranch && !branchList) return;
        initStat();
        if (selectedClass) getStatClass();
        else if (selectedNurseryUniq) getStatNurseryUniq();
        else getStatBranch();
        return () => {};
    }, [statPeriod]);

    useEffect(() => {
        if (selectedNurseryUniq) getStatNurseryUniq();
        else if (isFirstDataLoaded && !statBranch && selectedBranch) getStatBranch();
        return () => {};
    }, [selectedNurseryUniq]);

    useEffect(() => {
        if (selectedClass) getStatClass();
        else if (!statNurseryUniq && selectedNurseryUniq) getStatNurseryUniq();
        return () => {};
    }, [selectedClass]);

    const changePage = (e) => {
        const urlBase = process.env.REACT_APP_BASE_URL;
        document.location.href = urlBase + "/stat/note/" + e;
    }

    const initStat = () => {
        setStatBranch(false);
        setStatNurseryUniq(false);
        setClassList(false);
        setStatClass(false);
    };

    const getStatBranch = () => {
        initStat();
        axios({
            method: "POST",
            url: `/api/stat_note/branch/${selectedBranch.id}/nurseries`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data;
                    stat.stats = stat.stats.sort((a, b) => b.playCountSum - a.playCountSum);
                    setStatBranch(stat.stats);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
                setFirstDataLoaded(true);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const getStatNurseryUniq = () => {
        setStatNurseryUniq(false);
        setClassList(false);
        setStatClass(false);
        axios({
            method: "POST",
            url: `/api/stat_note/branch/${selectedBranch.id}/nurseries/${selectedNurseryUniq.nurseryUniqId}`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stats = result.data.stats;
                    const classes = result.data.classes;

                    setStatNurseryUniq(stats);
                    setClassList(classes);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const getStatClass = () => {
        setStatClass(false);
        axios({
            method: "POST",
            url: `/api/stat_note/branch/${selectedBranch.id}/nurseries/${selectedNurseryUniq.nurseryUniqId}/teachers/${selectedClass.sid}`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stats = result.data.stats;

                    setStatClass(stats);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const onPeriodChangeHandler = (startDate, endDate, type) => {
        setStatPeriod(getPeriodToStat({ startDate, endDate, type }));
    };
    const onViewBack = () => {
        if (selectedClass) {
            setClass(false);
        } else if (selectedNurseryUniq) {
            setNurseryUniq(false);
            setStatNurseryUniq(false);
            setClassList(false);
        }
    };

    const onBranchSelected = (e) => {
        const { name, value } = e.target;
        setBranch(branchList.find((b) => b.id == value));
    };

    const onNurseryUniqSelected = (selected) => {
        setNurseryUniq(selected);
    };

    const onClassSelected = (selected) => {
        const cls = classList.find((c) => c.sid === parseInt(selected, 10));
        setClass(cls ? cls : false);
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <h2 className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-4pageheader-title">
                            토모노트
                        </h2>
                        {!isRoleBranch && (<div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 float-right">
                            <select className="form-control form-control-lg" name="month" value={"branch"} onChange={(e) => changePage(e.target.value)} style={{ fontSize: "1.3em" }}>
                                <option value="hq">본사</option>
                                <option value="branch">지사</option>
                            </select>
                        </div>)}
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row align-items-center mb-3">
                        {selectedNurseryUniq != false && (
                            <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4" style={{ minWidth: "59px", maxWidth: "59px" }}>
                                <button
                                    className="btn btn-default"
                                    style={{
                                        marginRight: "10px",
                                        border: "0px",
                                        width: "44px",
                                    }}
                                    type="button"
                                    onClick={onViewBack}
                                >
                                    <span className="fa fa-lg fa-chevron-left" aria-hidden="true" />
                                </button>
                            </div>
                        )}
                        <div className="col-xl-3 col-lg-3 col-md-9 col-sm-9 col-8">
                            <SelectStatPeriod id="select-stat-period" showLastYearShortCut={showLastYearShortCut} minDate={minDate} onPeriodChangeHandler={onPeriodChangeHandler} />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-5 col-sm-12 col-12">
                            {selectedNurseryUniq === false && branchList && (
                                <select className="form-control form-control-sm" name="branch-select" value={selectedBranch.id} onChange={(e) => onBranchSelected(e)}>
                                    {branchList.map((b) => {
                                        return (
                                            <option key={`branch-${b.id}`} value={b.id}>
                                                {b.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            {selectedNurseryUniq && classList && (
                                <select className="form-control form-control-sm" name="class-select" value={selectedClass ? selectedClass.sid : "-"} onChange={(e) => onClassSelected(e.target.value)}>
                                    <option value="-">전체</option>
                                    {classList.map((c) => {
                                        return (
                                            <option key={`class-${c.sid}`} value={c.sid}>
                                                {c.className}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                        </div>
                        <ExcelDownloadBtn view={parentRef} statPeriod={statPeriod} />
                    </div>
                    {selectedNurseryUniq === false && (
                        <Branch
                            isRoleBranch={isRoleBranch}
                            statPeriod={statPeriod}
                            selectedBranch={selectedBranch}
                            statAll={statBranch}
                            onNurseryUniqSelected={onNurseryUniqSelected}
                            ref={parentRef}
                        />
                    )}
                    {selectedNurseryUniq && selectedClass === false && (
                        <Nursery
                            statPeriod={statPeriod}
                            selectedBranch={selectedBranch}
                            selectedNurseryUniq={selectedNurseryUniq}
                            stats={statNurseryUniq}
                            classes={classList}
                            onClassSelected={onClassSelected}
                            ref={parentRef}
                        />
                    )}
                    {selectedNurseryUniq && selectedClass && (
                        <Class
                            statPeriod={statPeriod}
                            selectedBranch={selectedBranch}
                            selectedNurseryUniq={selectedNurseryUniq}
                            selectedClass={selectedClass}
                            stats={statClass}
                            classes={classList}
                            ref={parentRef}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatTomonoteBranch;
